module.exports = __webpack_public_path__ + "img/24.b881345b.jpg";